import { store } from "../../redux/store";
import { showToast } from "../../redux/Reducer/toastReducer";

export const showErrorToast = (message) => {
  store.dispatch(showToast({ message: `${message}`, type: "error" }));
};

export const showSuccessToast = (message) => {
  store.dispatch(showToast({ message: `${message}`, type: "success" }));
};
